import httpService from '@/api/httpService'

const BalanceApi = (() => {
  const apiPostfix = 'balance'

  return {
    apiPostfix: apiPostfix,

    async getList (payload) {
      const response = await httpService.post(`${apiPostfix}/show`, payload)
      return response.data
    },
    async getInfo () {
      const response = await httpService.get(`${apiPostfix}`)
      return response.data
    },
    async confirmBalance () {
      const response = await httpService.get(`${apiPostfix}/confirm`)
      return response.data
    },
    async openDocument (payload) {
      const response = await httpService.post(`${apiPostfix}/open_document`, payload)
      return response.data
    }
  }
})()

export default BalanceApi
